module.exports = __webpack_public_path__ + "static/img_1038-dbba0ffac5bde1721c38137a93c6e0f6.webp";